<template>
  <div>
    <h1 v-html="modelValue.Content.StepSix.LabelTitle" />
    <section>
      <p v-html="modelValue.Content.StepSix.LabelBody" />
    </section>
  </div>
</template>
<script>
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'ReceiptStudy',
  props: {
    modelValue: {
      type: Object,
      default() {
        return {};
      }
    },
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted() {
    Utility.pushToTagManager({
      event: 'track-ga-vp',
      virtualPath: '/virtual/studie-prisberegner-06-kvittering',
      virtualTitle: 'Virtuel - Beregn pris - Studie - kvittering'
    });
    Utility.pushToTagManager({
      event: 'track-event',
      eventCategory: 'studie prisberegner',
      eventAction: '06 kvittering',
      eventLabel: '',
      eventValue: '0',
      eventNoninteraction: true,
      data: {}
    });
  }
};
</script>
